import { createReducer, on } from '@ngrx/store';
import { castProfileActions } from '../actions';

export const featureKey = 'cast-profile';

export const initialState: any = null;

export const reducer = createReducer(
    initialState,
    on(castProfileActions.updateImageView, (state) => ({...state }))
);
